import classNames from 'classnames';

import { styled } from '@project44/manifest-ds';

import { IconLibrary } from '../../assets/IconLibrary';
import { EntityEnum } from '../../definitions/enums/Entity';
import { EntityColorEnum } from '../../definitions/enums/EntityColor';
import { BlockNumberType } from '../../definitions/types/BlockNumber';
import { BlockNumberStyleType } from '../../definitions/types/BlockNumberStyle';
import { Icon } from '../Icon';

// STYLE
const StyledBlockNumber = styled('span', {
  alignItems: 'center',
  borderRadius: '$small',
  display: 'flex',
  flexShrink: 0,
  justifyContent: 'center',
  '&.text': {
    backgroundColor: 'transparent',
    color: 'inner',
  },
  variants: {
    entityType: {
      [EntityEnum.shipment]: {
        '&.filled': {
          backgroundColor: EntityColorEnum[EntityEnum.shipment],
          color: 'white',
        },
      },
      [EntityEnum.order]: {
        '&.filled': {
          backgroundColor: EntityColorEnum[EntityEnum.order],
          color: 'white',
        },
      },
    },
  },
});

// COMPONENT
export const BlockNumber = ({
  className,
  entityType,
  number = '1',
  size = 20,
  type = 'text',
}: {
  className?: string;
  entityType: EntityEnum;
  number?: BlockNumberType;
  size?: number;
  type?: BlockNumberStyleType;
}) => {
  return (
    <StyledBlockNumber
      entityType={entityType}
      className={classNames(type, className)}
      data-testid="block-number"
      css={{ width: size, height: size }}
    >
      <IconLibrary />
      <Icon name={number} size={size > 0 ? `${size / 2}px` : '0'} />
    </StyledBlockNumber>
  );
};
